import { render, staticRenderFns } from "./resourceModel.vue?vue&type=template&id=b6c65b74&scoped=true&"
import script from "./resourceModel.vue?vue&type=script&lang=js&"
export * from "./resourceModel.vue?vue&type=script&lang=js&"
import style0 from "./resourceModel.vue?vue&type=style&index=0&id=b6c65b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c65b74",
  null
  
)

export default component.exports